<template>
  <div v-if="hidePage">
    <h3>消防电源</h3>
    <!-- 表格 -->
    <!-- stripe  是否为斑马线 -->
    <div class="table" style="margin: 30px ;">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column align="center" header-align="center" label="序号" type="index" width="80px"></el-table-column>
        <el-table-column align="center" header-align="center" label="设备名称">
          <template slot-scope="scope">
            <div v-show="!flag[scope.$index]" :key="isbutton">
              <span>{{ scope.row.deviceName == null ? "暂无数据" : scope.row.deviceName }}</span>
              <i class="el-icon-edit-outline" style="margin-left: 20px;cursor: pointer;" @click="edit(scope.row.id, scope.row, scope.$index)"></i>
            </div>
            <el-input v-show="flag[scope.$index]" ref="inptVal" v-model="scope.row.deviceName" @blur="sure(scope.$index, scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" header-align="center" label="电源状态">
          <el-table-column align="center" header-align="center" label="主电状态" width="140px">
            <template slot-scope="scope">
              <div class="state">
                <div style="border: 2px dashed  #797979;border-radius: 50%;">
                  <p :class="true ? 'kuai-gray' : scope.row.state == null ? 'kuai-gray' : scope.row.state == 1 ? 'kuai-red' : 'kuai-green'"></p>
                </div>
                <!-- <p style="margin-top: 8px;">{{ scope.row.state == null ? "主电未知" : scope.row.state == 1 ? "主电正常" : "主电异常" }}</p> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" header-align="center" label="备电状态" width="140px">
            <template slot-scope="scope">
              <div class="state">
                <div style="border: 2px dashed  #797979;border-radius: 50%;">
                  <p :class="true ? 'kuai-gray' : scope.row.state == null ? 'kuai-gray' : scope.row.state == 0 ? 'kuai-red' : 'kuai-green'"></p>
                </div>
                <!-- <p style="margin-top: 8px;">{{ scope.row.state == null ? "备电未知" : scope.row.state == 1 ? "备电正常" : "备电异常" }}</p> -->
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" header-align="center" label="供电状态">
          <el-table-column align="center" header-align="center" label="主电状态" width="140px">
            <template slot-scope="scope">
              <div class="state">
                <div style="border: 2px dashed  #797979;border-radius: 50%;">
                  <p :class="scope.row.state == 1 ? 'kuai-green' : 'kuai-gray'"></p>
                </div>
                <p style="margin-top: 8px;">{{ false ? "" : "主电供电" }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" header-align="center" label="备电状态" width="140px">
            <template slot-scope="scope">
              <div class="state">
                <div style="border: 2px dashed  #100808;border-radius: 50%;">
                  <p :class="scope.row.state == 0 ? 'kuai-green' : 'kuai-gray'"></p>
                </div>
                <p style="margin-top: 8px;">{{ false ? "" : "备电供电" }}</p>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" header-align="center" label="位置" prop="position">
          <template slot-scope="scope">
            <p>{{ scope.row.position == null ? "暂无数据" : scope.row.position }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" header-align="center" label="回路号" prop="remark">
          <template slot-scope="scope">
            <p>{{ scope.row.remark == null ? "暂无数据" : scope.row.remark }}</p>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import {SupplyList} from "../../api/facility.js";
import config from "../../utils/config.js";

export default {
  props: ["cpNum"],
  data() {
    return {
      tableData: [],
      flag: [], // 让修改按钮隐藏
      hidePage: false, // 隐藏页面
      isbutton: 0, // 找到对应的 key 值
      websock: null,
    };
  },
  watch: {
    cpNum() {
      this.getList();
    },
  },
  created() {
    this.initWebSocket();
  },
  mounted() {
    if (this.cpNum) this.getList();
  },
  destroyed() {
    this.websock.close(); //离开路由之后断开websocket连接
  },
  methods: {
    getList() {
      var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "93fe79c642aa44e182aa3c793dfc9b55" : this.cpNum;
      SupplyList({companyNum: cNum}).then((res) => {
        log(res);
        if (res.rows.length) {
          this.tableData = res.rows;
          this.hidePage = true;
        } else {
          this.$message.warning("该业务尚且开通，清联系管理员");
          this.hidePage = false;
        }
      });
    },
    edit(id, row, index) {
      log(id, row.position, index);
      this.isbutton++;
      this.flag[index] = true;
    },
    sure(index, row) {
      var obj = {deviceNo: row.deviceNo, id: row.id, type: row.type, deviceName: row.deviceName};
      this.flag[index] = false;
      // 请求接口
      this.$put(`/device/monitorDevice/editDeviceName`, obj).then((res) => {
        this.isbutton++;
        if (res.code == 200) {
          this.$message({message: res.msg,type: "success", duration: 700,});
        }
      });
    },
    initWebSocket() {
      let wsUrl = "";
      if (process.env.NODE_ENV == "development") {
        //本地
        wsUrl = config.wsUrltest;
      } else if (process.env.NODE_ENV == "production") {
        //线上
        wsUrl = config.wsUrl;
      }
      //初始化weosocket
      // const wsuri = "ws://47.105.170.47:8888/ws/mqt";
      // const wsuri = "ws://192.168.0.49:8899/ws/trweb";
      this.websock = new WebSocket(wsUrl);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      log("链接");
      //连接建立之后执行send方法发送数据
      let message = "fasong";
      this.websocketsend(JSON.stringify(message));
    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) {
      //数据接收
      const redata = JSON.parse(e.data);
      for (const iterator of redata) {
        if (iterator.type == "273" && iterator.wsType == 1) {
          for (const item of this.tableData) {
            // console.log(item.idStr, iterator.idStr);
            if (item.idStr == iterator.idStr) {
              item = Object.assign(item, iterator);
              // item.electric = iterator.electric;g
            }
          }

          this.list = [...this.list];
        }
      }
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-edit-outline {
  font-size: 18px;
  font-weight: bold;
}

.wind_speed {
  width: 25px;
  height: 25px;
  margin-left: 10px;
  // transform: rotate3d(360deg);
  animation: turn 1s linear infinite;
}

.wind_speedNull {
  width: 25px;
  height: 25px;
  margin-left: 10px;
}

.turn {
  animation: turn 0.1s linear infinite;
}

/* 
  turn : 定义的动画名称
  10s : 动画时间
  linear : 动画平滑
  infinite :使动画无限循环
  transform:rotate(旋转角度)
  %0:动画开始
  %100:动画结束
  */
@keyframes turn {
  0% {
    transform: rotate(0deg);
  }

  20% {
    transform: rotate(-72deg);
  }

  40% {
    transform: rotate(-144deg);
  }

  60% {
    transform: rotate(-216deg);
  }

  80% {
    transform: rotate(-288deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

.page {
  margin-right: 50px;
}

::v-deep .el-table thead.is-group th {
  background: #ffffff;
}

.kuai-red {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: red;
  // border: 10px dotted #797979;
}

.kuai-green {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: green;
  // border: 10px dotted #797979;
}

.kuai-gray {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: gray;
  // border: 10px dotted #797979;
}

.state {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
</style>
